import React from 'react'
import styled from '@emotion/styled'
import { Market } from 'api'
import { Groupbox, ModalFooter, ModalWindow } from 'view/components/panels'
import { TextButton, TextButtonType } from 'view/components/buttons'
import { DialogField, DialogRow } from 'view/components/inputs'
import { Locale, Translation } from 'locale'
import { iconSet } from 'view/components/icons'
import * as constants from 'view/styles/constants'

interface SuspensionDialogProps {
  euMarketClosed: boolean
  euMarketPreOpen: boolean
  euPlatformSuspended: boolean
  usMarketClosed: boolean
  usMarketPreOpen: boolean
  usPlatformSuspended: boolean
  organisationSuspended: boolean
  userSuspended: boolean
  onClose?: () => unknown
}

const Container = styled(Groupbox)`
  padding: 20px 20px 0 20px;
  font-weight: ${constants.FontWeight.Bold};
`

const Title = styled.div`
  display: flex;
  align-items: center;
  & > span {
    display: flex;
    align-items: center;
    height: 26px;
    margin-left: 10px;
  }
`

export const SuspensionDialog: React.FunctionComponent<SuspensionDialogProps> = props => {
  const {
    euMarketClosed,
    euMarketPreOpen,
    euPlatformSuspended,
    usMarketClosed,
    usMarketPreOpen,
    usPlatformSuspended,
    organisationSuspended,
    userSuspended,
    onClose
  } = props
  const title = (
    <Title data-test-id={'SuspensionDialog-Title-Suspensions'}>
      {iconSet.suspensionIcon}
      <span>{Locale.translate(Translation.TC_SUSPENSIONS)}</span>
    </Title>
  )

  return (
    <ModalWindow title={title}>
      <Container dataTestId={'SuspensionDialog-Container'}>
        {euMarketClosed && !euPlatformSuspended && (
          <DialogRow>{Locale.translate(Translation.SC_MARKET_CLOSED, { market: Market.EUROPE })}</DialogRow>
        )}
        {euMarketPreOpen && !euPlatformSuspended && (
          <DialogRow>{Locale.translate(Translation.SC_MARKET_PRE_OPEN, { market: Market.EUROPE })}</DialogRow>
        )}
        {euPlatformSuspended && <DialogRow>{Locale.translate(Translation.SC_PLATFORM_SUSPENDED, { market: Market.EUROPE })}</DialogRow>}
        {usMarketClosed && !usPlatformSuspended && (
          <DialogRow>{Locale.translate(Translation.SC_MARKET_CLOSED, { market: Market.US })}</DialogRow>
        )}
        {usMarketPreOpen && !usPlatformSuspended && (
          <DialogRow>{Locale.translate(Translation.SC_MARKET_PRE_OPEN, { market: Market.US })}</DialogRow>
        )}
        {usPlatformSuspended && <DialogRow>{Locale.translate(Translation.SC_PLATFORM_SUSPENDED, { market: Market.US })}</DialogRow>}
        {organisationSuspended && <DialogRow>{Locale.translate(Translation.SC_ORGANISATION_SUSPENDED)}</DialogRow>}
        {userSuspended && <DialogRow>{Locale.translate(Translation.SC_USER_SUSPENDED)}</DialogRow>}
      </Container>
      <ModalFooter>
        <DialogField>
          <TextButton dataTestId={'SuspensionDialog-TextButton-ButtonClose'} type={TextButtonType.Tertiary} onClick={onClose}>
            {Locale.translate(Translation.TC_BUTTON_CLOSE)}
          </TextButton>
        </DialogField>
      </ModalFooter>
    </ModalWindow>
  )
}
